import type { NavGroup } from '@/types';

/**
 * Arborescence de navigation de la sidebar.
 * Décision structurante du brief : « Chantier » fait office de projet,
 * aucun module « projet » distinct. Les noms d'icônes sont des composants
 * Lucide résolus dans SidebarNav.
 */
export const NAV_GROUPS: NavGroup[] = [
  {
    title: 'Pilotage',
    items: [
      { label: 'Tableau de bord', to: '/', icon: 'LayoutDashboard' },
      { label: 'Tâches', to: '/taches', icon: 'ListChecks' },
      { label: 'Messagerie', to: '/messagerie', icon: 'Mail' },
    ],
  },
  {
    title: 'Commercial',
    items: [
      { label: 'CRM', to: '/crm', icon: 'Building2' },
      { label: "Appels d'offres", to: '/appels-offres', icon: 'FileSignature' },
      { label: 'Devis', to: '/devis', icon: 'ScrollText' },
      { label: 'Clients', to: '/clients', icon: 'Contact' },
    ],
  },
  {
    title: 'Chantiers',
    items: [
      { label: 'Chantiers', to: '/chantiers', icon: 'HardHat' },
      { label: 'Situations de travaux', to: '/situations', icon: 'FileBarChart' },
      { label: 'Contrôle des coûts', to: '/couts', icon: 'TrendingUp' },
      { label: 'Référentiel documentaire', to: '/documents-entreprise', icon: 'FolderArchive' },
    ],
  },
  {
    title: 'Facturation & Trésorerie',
    items: [
      { label: 'Factures', to: '/factures', icon: 'FileText' },
      { label: 'Dépenses', to: '/depenses', icon: 'Receipt' },
      { label: 'Trésorerie', to: '/tresorerie', icon: 'Banknote' },
      { label: 'Chèques', to: '/cheques', icon: 'CheckCircle2' },
    ],
  },
  {
    title: 'Comptabilité & Fiscal',
    items: [
      { label: 'Comptabilité SCF', to: '/comptabilite', icon: 'BookOpenCheck' },
      { label: 'Immobilisations', to: '/immobilisations', icon: 'Building2' },
      { label: 'Fiscalité (G50)', to: '/fiscalite', icon: 'Landmark' },
      { label: 'Liasse fiscale', to: '/liasse', icon: 'FileSpreadsheet' },
    ],
  },
  {
    title: 'Ressources',
    items: [
      { label: 'RH & paie', to: '/rh', icon: 'Users' },
      { label: 'Parc & matériel', to: '/engins', icon: 'Truck' },
      { label: 'HSE — Sécurité', to: '/hse', icon: 'ShieldCheck' },
    ],
  },
  {
    title: 'Achats & Stock',
    items: [
      { label: 'Achats', to: '/achats', icon: 'ShoppingCart' },
      { label: 'Stock', to: '/stock', icon: 'Boxes' },
      { label: 'Fournisseurs', to: '/fournisseurs', icon: 'Truck' },
      { label: 'Sous-traitants', to: '/sous-traitants', icon: 'Handshake' },
    ],
  },
  {
    title: 'Administration',
    items: [
      { label: 'Paramètres', to: '/parametres', icon: 'Settings', roles: ['ADMIN', 'DIRECTEUR'] },
      { label: "Journal d'activité", to: '/journal', icon: 'History', roles: ['ADMIN', 'DIRECTEUR'] },
      { label: 'Archives & Corbeille', to: '/corbeille', icon: 'Trash2', roles: ['ADMIN', 'DIRECTEUR'] },
      { label: 'Sauvegarde', to: '/sauvegarde', icon: 'Database', roles: ['ADMIN', 'DIRECTEUR'] },
    ],
  },
];
